import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';
import {QuestionCircleUnfilledIcon} from '~library/svg/QuestionCircleUnfilledIcon';

export const OnboardingModalButton = ({visible}) => {
  const dispatch = useDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const onClickHandler = useCallback(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {forceShowOnboardingModal: true},
    });
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div>
      <button
        className="unstyled-button"
        data-qa-id="onboard-open"
        onClick={onClickHandler}
        type="button"
      >
        <QuestionCircleUnfilledIcon />
      </button>
    </div>
  );
};
